import React from "react";
import { X } from "lucide-react";

import { getTagIcon, tagChipStyle } from "./tagIcons";

/**
 * A coloured tag/label pill.
 *   <TagChip tag={{ name, color, icon }} />
 *   <TagChip tag={tag} onRemove={fn} />   // shows an × button
 */
export default function TagChip({ tag, size = "sm", onRemove, className = "" }) {
  if (!tag) return null;

  const Icon = getTagIcon(tag.icon);
  const dims =
    size === "xs"
      ? { pad: "px-1.5 py-[1px] text-[9px]", icon: 9 }
      : { pad: "px-2 py-0.5 text-[10px]", icon: 11 };

  return (
    <span
      className={`inline-flex max-w-full items-center gap-1 rounded-full border font-semibold leading-none ${dims.pad} ${className}`}
      style={tagChipStyle(tag.color)}
      title={tag.name}
    >
      {Icon && <Icon size={dims.icon} className="shrink-0" />}
      <span className="truncate">{tag.name}</span>
      {onRemove && (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onRemove(tag);
          }}
          className="ml-0.5 shrink-0 opacity-60 transition hover:opacity-100"
          aria-label={`Remove ${tag.name}`}
        >
          <X size={dims.icon} />
        </button>
      )}
    </span>
  );
}
